// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {
    generalServiceUnitSelector,
    getGeneralServiceUnit,
    insertGeneralServiceUnit,
    updateGeneralServiceUnit,
} from "./generalServiceUnitSlice";

import {Colors} from "../../../assets/Colors";

const GeneralServiceUnitPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const generalServiceUnit = useSelector(generalServiceUnitSelector);

    useEffect(() => {
        dispatch(
            getGeneralServiceUnit({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (
            search !== "" &&
            generalServiceUnit.isGetSuccess &&
            !generalServiceUnit.isGetFetching
        ) {
            let calc = generalServiceUnit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = generalServiceUnit.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (
            search === "" &&
            generalServiceUnit.isGetSuccess &&
            !generalServiceUnit.isGetFetching
        ) {
            let calc = generalServiceUnit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = generalServiceUnit.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !generalServiceUnit?.isGetFetching &&
            generalServiceUnit.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = generalServiceUnit?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = generalServiceUnit.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getGeneralServiceUnit({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (generalServiceUnit.isGetSuccess) {
                alertService.success(generalServiceUnit.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getGeneralServiceUnit({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (generalServiceUnit.isUpdateSuccess) {
                alertService.success(generalServiceUnit.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateGeneralServiceUnit({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetGeneralServiceUnit(params) {
    //   return dispatch(getGeneralServiceUnit(params));
    // }

    function handleInsertGeneralServiceUnit(param) {
        setInsertFetch(true);
        const params = {
            GeneralServiceUnitName: param.inputOneValue,
            CategoryID: param.dropDownGeneralServiceUnitValue,
        };

        dispatch(insertGeneralServiceUnit(params));
    }

    function handleUpdateGeneralServiceUnit(param) {
        setUpdateFetch(true);

        const params = {
            GeneralServiceUnitName: param.inputOneValue,
            GeneralServiceUnitID: currentData.GeneralServiceUnitID,
            KategoriGeneralServiceUnitID: param.dropDownGeneralServiceUnitValue,
            status: param.status,
        };
        dispatch(updateGeneralServiceUnit(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getGeneralServiceUnit(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getGeneralServiceUnit(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = generalServiceUnit.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? generalServiceUnit.count : newCount,
            search: search,
        };
        dispatch(getGeneralServiceUnit(params));

        setPage(1);
        setCount(newCount === "-1" ? generalServiceUnit.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="GeneralServiceUnit"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master GeneralServiceUnit"
                                tableData={generalServiceUnit.data}
                                colOneTitle="ID"
                                colOneData="GeneralServiceUnitID"
                                colTwoTitle="Nama Unit"
                                colTwoData="GeneralServiceUnitName"
                                colThreeTitle="Kategori"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={generalServiceUnit.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Unit"
                        inputOneTitle="Nama Unit"
                        dropDownGeneralServiceUnit={true}
                        dropDownGeneralServiceUnitValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertGeneralServiceUnit}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.GeneralServiceUnitID}
                        modal={handleModal}
                        modalTitle="Ubah Unit"
                        inputOneTitle="Nama Unit"
                        inputOneValue={currentData.GeneralServiceUnitName}
                        dropDownGeneralServiceUnit={true}
                        dropDownGeneralServiceUnitValue={currentData.CategoryID}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateGeneralServiceUnit}
                    />
                )}
            </div>
        );
    }
};

export default GeneralServiceUnitPage;
